import Tabs from "../components/tabs.js";
import History from "../components/history.js";
import PasswordChanger from "../components/passwordChanger.js";

class Lk {
  constructor() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
  }
  init() {
    this.container = document.querySelector(".lk");
    if (this.container === null) return;
    this.tabs = new Tabs(
      this.container.querySelectorAll(".tabs__tab[data-target]")
    );
    this.history = new History(this.container.querySelector(".history"));
    this.passwordChanger = new PasswordChanger(this.container.querySelector(".udata"));
  }
}

export default Lk;



// WEBPACK FOOTER //
// ./src/js/apps/lk.js